import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./productDisplay.css";
import PersonalisationModal from "../personalisationModal/personalisationModal";
import SuccessAlert from "../addToCartSuccess/addToCartSuccess";
import { ShopContext } from "../../context/shopContext";
import ProductSchema from "./productSchema";

const ProductDisplay = () => {
  const { addToCart } = useContext(ShopContext);
  const [product, setProduct] = useState(null);
  const [personalisationModal, setPersonalisationModal] = useState(false);
  const [showAddToCartAlert, setShowAddToCartAlert] = useState(false);
  const [showMessageAlert, setShowMessageAlert] = useState(false);

  const { productId } = useParams();

  useEffect(() => {
    if (!productId) return;

    fetch(`${process.env.REACT_APP_URL}/api/products/${productId}`)
      .then((response) => response.json())
      .then((data) => setProduct(data))
      .catch((error) => console.error("Error fetching product data:", error));
  }, [productId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [product]);

  const handleAddToCart = () => {
    if (!product) return;

    addToCart({ itemId: product.id });
    setShowAddToCartAlert(true);
    setTimeout(() => setShowAddToCartAlert(false), 3000);
  };

  const handleAddMessageSuccess = () => {
    setShowMessageAlert(true);
    setTimeout(() => setShowMessageAlert(false), 3000);
  };

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="product-display">
        <div className="product-display-left">
          <div className="product-display-img">
            <img
              className="product-display-main-img"
              src={product.image}
              alt={product.name}
            />
          </div>
        </div>

        <div className="product-display-right">
          <h1>{product.name}</h1>

          <div className="trustspot-inline-product" data-product-sku={product.id}>
            <span className="trustspot-review-count" data-product-sku={product.id}></span>
          </div>

          <div className="product-price-container">
            <div className="product-price">£{product.price}</div>
          </div>

          <div className="product-description">{product.shortDescription}</div>

          <div className="cta-btn-container">
            <Link to="/cart">
              <button className="product-display-atc-btn" onClick={handleAddToCart}>
                Add To Cart
              </button>
            </Link>
            <button
              className="product-display-am-btn"
              onClick={() => setPersonalisationModal(true)}
            >
              Add Message
            </button>
          </div>
        </div>
      </div>

      {personalisationModal && (
        <PersonalisationModal
          id={product.id}
          name={product.name}
          closePersonalisationModal={setPersonalisationModal}
          onMessageSuccess={handleAddMessageSuccess}
        />
      )}

      {showAddToCartAlert && (
        <SuccessAlert
          message="Product added to cart successfully!"
          onClose={() => setShowAddToCartAlert(false)}
        />
      )}

      {showMessageAlert && (
        <SuccessAlert
          message="Message added successfully!"
          onClose={() => setShowMessageAlert(false)}
        />
      )}

      {/* Schema Markup injected into <head> */}
      <ProductSchema product={product} />
    </div>
  );
};

export default ProductDisplay;
